// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"237":"analysis","946":"newmatch","966":"dashboard"}[chunkId] + "." + {"237":"f233e69d","946":"1b98dfd9","966":"78faf2bc"}[chunkId] + ".css";
};